import { useCallback } from 'react'

export type UseErrorHandlerOptions = {
  onUnexpectedError?: () => void
}

export type UseErrorHandlerResult = {
  handleError: (error: unknown) => void
}

export function useErrorHandler(options: UseErrorHandlerOptions): UseErrorHandlerResult {
  const { onUnexpectedError } = options
  const handleError = useCallback(
    (_error: unknown) => {
      onUnexpectedError?.()
    },
    [onUnexpectedError],
  )
  return { handleError }
}
